import { Button } from "@repo/ui/components/button";
import { useForm } from "@repo/ui/hooks/use-form";
import { Keyboard } from "../../../components/keyboard";
import { urlLoadProduct } from "../../../urls";
import { useNavigate } from "react-router";
import { Title } from "../../../components/title";

function Name() {
  const navigate = useNavigate();
  const { ref, values, handleChangeValue } = useForm({
    initialValues: {
      name: "",
    },
    onSubmit: () => {
      navigate(urlLoadProduct("price"), { state: { name: values.name } });
    },
  });
  return (
    <form ref={ref} className="flex flex-col items-center gap-4 w-full py-4">
      <Title>¿Cuál es el nombre del producto?</Title>
      <div
        className={`w-full bg-white border border-gray-200 rounded-md flex items-center justify-center h-12 pt-1 ${
          values.name === "" ? "text-gray-400" : ""
        }`}
      >
        {values.name}
      </div>
      <Keyboard
        onChange={(value) => {
          handleChangeValue("name", value);
        }}
        value={values.name}
        mode="capitalize"
      />
      <Button
        type="submit"
        disabled={values.name.length < 3}
        size="4xl"
        variant="pos"
        className="w-full"
      >
        Continuar
      </Button>
    </form>
  );
}

export const route = {
  path: urlLoadProduct(),
  element: <Name />,
};
